import { IonButton, IonCheckbox, IonPopover, IonCol, IonContent, IonGrid, IonImg, IonInput, IonItem, IonLabel, IonPage, IonRow, IonSelect, IonSelectOption, IonText, useIonViewDidLeave, useIonViewWillEnter } from '@ionic/react';
import { useRef, useState } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useHistory, useParams } from 'react-router';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import AuthServ from '../../services/auth';
import { editFundraiser, fetchSingleFundraiser } from '../../services/fundraise_service';
import { fetchOrgsWhereAdmin } from '../../services/org_service';
import { d_m_y_str } from '../../utlities/ymd';


interface FundraiseCreateProps {
  user: User
}

const FundraiseEdit: React.FC<FundraiseCreateProps> = ({ user }) => {

  const history = useHistory();

  const ref = useRef<HTMLIonRowElement>(null)

  const { id } = useParams<{ id: string; }>();

  const siteText = translation();

  const lan = siteText.lan.replace("/", "");

  const getFormatedDate = (dateString: any) => {
    let fullDate = new Date(dateString);
    let year = fullDate.getFullYear();

    let month = `${fullDate.getMonth() + 1}`;
    let day = `${fullDate.getDate()}`;

    if (month.length < 2) { month = 0 + month };
    if (day.length < 2) { day = 0 + day };

    let formatedDate = `${year}-${month}-${day}`;

    return formatedDate;

  }

  const tomorrow = new Date();

  tomorrow.setDate(new Date().getDate());

  const [title, setTitle] = useState<string | null>();
  const [start_date, setStartDate] = useState<string | null>();
  const [imageUrl, setImageUrl] = useState<string>('');
  const [end_date, setEndDate] = useState<string | null>();
  const [defaultDates, setDefaultDates] = useState({ start: '', end: '' })
  const [reason, setReason] = useState<string | null>();
  const [image, setImage] = useState<File | null>();
  const [description, setDescription] = useState<any>();
  const [target, setTarget] = useState<string | null>();
  const [destination, setDestination] = useState<any | null>();
  const [destination_org, setDestinationOrg] = useState<any | null>();
  const [createrOrgs, setCreatorOrgs] = useState<[any]>();
  const [createrOrg, setCreatorOrg] = useState<any>();
  const [newImage, setNewImage] = useState<string | null>();
  const [allowStop, setAllowStop] = useState<boolean>(false);
  const [anonymous, setAnonymous] = useState<boolean>()
  const [disable, setDisabled] = useState<boolean>(true);

  const popover = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const [isProcesseng, setIsProcessing] = useState<string>()


  const completeDonation = () => {
    setPopoverOpen(false)
    setTimeout(() => {
      history.push(`/${lan}/account/fundraise`)
    }, 30)
  }
  // edit anonymous
  const onSubmit = (e: any, stop: boolean) => {
    e.preventDefault();
    let stopValue = 1;
    let anonymousValue = 1;
    if (!stop) { stopValue = 0; }
    if (!anonymous) { anonymousValue = 0 }

    setDisabled(true);
    setIsProcessing('processing')
    setPopoverOpen(true)

    let data = {
      title: title,
      file: image,
      imageUrl: imageUrl,
      status: 'publish',
      acf: {
        start_date: start_date,
        end_date: end_date,
        reason: reason,
        description: description,
        target: target,
        anonymous: anonymousValue,
        status: stopValue,
        author_org: createrOrg
      }
    }

    editFundraiser(data, id).then(
      (m: any) => {
        if (m?.update_message) {
          setIsProcessing('done');
          setDisabled(false);
        } else {
          setIsProcessing('error')
          setDisabled(false);
          return
        }
      }
    )
  }

  const scrollToRef = () => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const Auth = new AuthServ();

  useIonViewWillEnter(() => {
    setDisabled(true);
    fetchSingleFundraiser(id).then(
      m =>
        Auth.fetchAUser(m.message.author).then(
          (n: any) => {
            setTitle(m.message.title.rendered);
            setStartDate(() => d_m_y_str(m.message.acf.start_date));
            setEndDate(() => d_m_y_str(m.message.acf.end_date));
            setDefaultDates({ start: d_m_y_str(m.message.acf.start_date), end: d_m_y_str(m.message.acf.end_date) })
            setReason(m.message.acf.reason);
            setImageUrl(m.message.acf.image);
            setDescription(m.message.acf.description);
            setTarget(m.message.acf.target);
            setDestination(m.message.acf.destination)
            setDestinationOrg(m.message.acf.destination_org ? m.message.acf.destination_org.post_title : null);
            setAnonymous(m.message.acf.anonymous)
            setCreatorOrg(m.message.acf.author_org?m.message.acf.author_org[0]:null)
            setDisabled(false);
            fetchOrgsWhereAdmin(user.id).then(m => setCreatorOrgs(m.message))
          }

        )
    )

  }, [id])

  useIonViewDidLeave(() => {
    setTitle(null);
    setStartDate(null);
    setEndDate(null);
    setDefaultDates({ start: '', end: '' });
    setReason(null);
    setImageUrl('');
    setDescription(null);
    setTarget(null);
    setDestination(null)
    setDestinationOrg(null);
    setAllowStop(false)
    setAnonymous(undefined)
    setCreatorOrg(undefined)
    setCreatorOrgs(undefined)
  })

  const prepareImage = (e: any) => {
    e.preventDefault();
    setImage(e.target.files[0])
    setNewImage(URL.createObjectURL(e.target.files[0]));
  }

  const checkAllowStop = (e: any) => {
    e.preventDefault();
    if (e.target.value !== 'STOP') {
      setAllowStop(false)
      return
    }
    setAllowStop(true)
  }


  return (
    <IonPage>
      <IonContent>
        <IonGrid className='innerBody accountSectionSpacingBottom'>
          <IonRow>
            <IonCol className='pageContent' offsetSm='1' sizeSm='8'>
              <h1>{siteText.fundraiseEditPageTitle}</h1>
              <p>{siteText.stopFundraiserInfo}<a className='ion-padding-start ion-padding-end' style={{ cursor: 'pointer' }} onClick={scrollToRef} > {siteText.stopFundraiserIndicationButton}</a></p>
            </IonCol>
          </IonRow>

          <IonRow>
            <IonCol offsetSm='1' sizeSm='8'>
              <h2>{siteText.fundraiseEditSectionTitle}</h2>

              <form onSubmit={e => onSubmit(e, false)}>
                <IonRow>
                  <IonCol sizeXs='12'>
                    <IonLabel position="stacked" >{siteText.fundraiseCreateTitleLabel}</IonLabel>
                    <IonInput className="ion-margin-bottom ion-margin-top" value={title} placeholder={siteText.fundraiseCreateTitleHolder} min="0" type="text" onIonChange={e => setTitle(e.detail.value)}></IonInput>

                    <IonLabel position="stacked">{siteText.fundraiseCreateReasonLabel}
                    </IonLabel>
                    <IonInput className="ion-margin-bottom ion-margin-top" value={reason} placeholder={siteText.fundraiseCreateReasonHolder} onIonChange={e => setReason(e.detail.value)} ></IonInput>

                    <IonLabel position="stacked">{siteText.fundraiseEditDestinationLabel}</IonLabel>
                    <IonInput className='ion-margin-bottom ion-margin-top' value={destination === "self" ? "My SwissDonations account" : destination_org} disabled ></IonInput>
                    <p>{siteText.fundraiseEditDestinaitonNote}</p>

                    <IonLabel position="stacked">{siteText.fundraiseCreatePublishAsOrgLabel}</IonLabel>
                    <IonSelect value={createrOrg} onIonChange={e => setCreatorOrg(e.detail.value)} style={{ width: '100%' }} disabled={!createrOrgs || createrOrgs.length < 1} placeholder="Pick an organisation">
                      <IonSelectOption value={''}>None</IonSelectOption>
                      {createrOrgs && createrOrgs.map((orgPage, key) => <IonSelectOption key={key} value={orgPage.id} dangerouslySetInnerHTML={{ __html: orgPage.title }}></IonSelectOption>)}
                    </IonSelect>
                    <p>{siteText.fundraiseCreatePublishAsOrgNotice}</p>

                  </IonCol>
                  <IonCol sizeXs='12'>
                    <div className="ion-margin-top ion-margin-bottom">
                      <IonLabel position="stacked">{siteText.fundraiseCreateStartLabel}</IonLabel>
                      {/*<IonDatetime className="ion-margin-top" value={start_date} showDefaultButtons={false} showClearButton={true} presentation="date" mode="ios" min={minDate} onIonChange={e => setStartDate(e.detail.value)} ></IonDatetime>*/}
                      <IonInput className='ion-margin-top' type='date' pattern="\d{4}-\d{2}-\d{2}" value={start_date ? getFormatedDate(start_date) : ''} min={getFormatedDate(start_date)} onIonChange={e => { if (e.detail.value) { setStartDate(e.detail.value) } else { setEndDate(defaultDates.start) } }} ></IonInput>

                    </div>
                  </IonCol>
                  <IonCol sizeXs='12'>
                    <div className="ion-margin-top ion-margin-bottom">
                      <IonLabel position="stacked">{siteText.fundraiseCreateEndLabel}</IonLabel>
                      {/*<IonDatetime className="ion-margin-top" value={end_date} showDefaultButtons={false} showClearButton={true} presentation="date" mode="ios"  onIonChange={e => setEndDate(e.detail.value)}></IonDatetime>*/}
                      <IonInput className='ion-margin-top' type='date' pattern="\d{4}-\d{2}-\d{2}" value={end_date ? getFormatedDate(end_date) : ''} onIonChange={e => { if (e.detail.value) { setEndDate(e.detail.value) } else { setEndDate(defaultDates.end) } }}></IonInput>

                    </div>
                  </IonCol>
                  <IonCol sizeXs='12'>
                    <IonLabel position="stacked">{siteText.fundraiseCreateAmountLabel}</IonLabel>
                    <IonItem lines='none' className="cashField ion-margin-top ion-margin-bottom">
                      <IonInput value={target} placeholder={siteText.fundraiseCreateAmountPlaceholder} min="0" type="number" onIonChange={e => setTarget(e.detail.value)}></IonInput>
                      <IonText className='ion-padding-start'>CHF</IonText>
                    </IonItem>

                    <IonLabel>{siteText.fundraiseCreateDescriptionLabel}</IonLabel>
                    <ReactQuill className='ion-margin-top ion-margin-bottom' placeholder={siteText.fundraiseCreateDescriptionPlaceholder} onChange={setDescription} value={description}></ReactQuill>


                    <IonRow>
                      <IonCol sizeSm='4' sizeMd='3'>
                        {newImage ? <IonImg src={newImage}></IonImg> :
                          <>
                            {imageUrl && <IonImg src={imageUrl}></IonImg>}
                          </>}
                        <br></br>
                        <IonLabel position="stacked">{siteText.fundraiseCreatePictureSelection}</IonLabel>
                      </IonCol>
                    </IonRow>
                    <input className="ion-margin-bottom ion-margin-top" id='imgUpload' placeholder="cover image" type="file" onChange={e => prepareImage(e)}></input>
                  </IonCol>
                </IonRow>
                <IonItem lines='none' className='ion-margin-top ion-margin-bottom'>
                  <IonCheckbox checked={anonymous} onIonChange={(e) => setAnonymous(e.detail.checked)}></IonCheckbox>
                  <IonLabel className='ion-margin-start'>{siteText.fundraiseCreateLabel}</IonLabel>
                </IonItem>

                <IonButton strong disabled={disable} slot="end" className="ion-margin-top" type="submit">
                  <IonText color='light'>{siteText.fundraiseEditConfirmButton}</IonText>
                </IonButton>


              </form>
            </IonCol>
          </IonRow>

          <IonRow id="section" ref={ref}>
            <IonCol offsetSm='1' sizeSm='8'>
              <h2>{siteText.fundraiseEditStopSectionTitle}</h2>

              <p className='altText'>{siteText.fundraiseEditStopNotice}</p>
              <p>{siteText.fundraiseEditStopLabel}</p>
              <IonInput style={{ maxWidth: '320px' }} onIonChange={checkAllowStop}></IonInput>
              <IonButton onClick={e => onSubmit(e, true)} disabled={!allowStop} mode='ios' color='danger'>Stop</IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
      <IonPopover ref={popover} isOpen={popoverOpen} backdropDismiss={false}>
        <IonContent>
          <IonGrid>
            <IonRow className="ion-padding">
              {isProcesseng === 'processing' &&
                <IonCol size="12">{siteText.fundraiseCreateEditAlertProcessing}</IonCol>}
              {isProcesseng === 'done' && <IonCol size="12">
                <p>{siteText.fundraiseEditSuccess}
                </p>
                <IonButton color="success" onClick={completeDonation}> <IonText color="light">{siteText.donateUseCreditDetailsDoneString}</IonText> </IonButton>
              </IonCol>}
              {isProcesseng === 'error' && <IonCol size="12">
                <p>{siteText.fundraiseCreateEditError}
                </p>
                <IonButton color="secondary" onClick={e => setPopoverOpen(false)}><IonText color="light">{siteText.donateUseCreditDetailsTryAgainString}</IonText> </IonButton>
              </IonCol>}
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPopover>
    </IonPage>

  );

};

export default FundraiseEdit;
